/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

export enum TSCockpitSelect {
    LETZER_MONAT = <any> 'LETZER_MONAT',
    DATUM_BEREICH = <any> 'DATUM_BEREICH',
}

export function getTSCockpitSelectValues(): Array<TSCockpitSelect> {
    return [
        TSCockpitSelect.LETZER_MONAT,
        TSCockpitSelect.DATUM_BEREICH,
    ];
}

export function cockpitSelectPrefix(): string {
    return 'TSCockpitSelect_';
}






// WEBPACK FOOTER //
// ./src/app/models/enums/TSCockpitSelect.ts